module.exports = __webpack_public_path__ + "img/gao6.eafcd9b6.png";